import AppDashboard from '../AppDashboard';
import LLMCallScreen from '../../components/admin/LLMCallScreen';

const AdminLLMCallPage = props => {
  return (
    <AppDashboard>
      <LLMCallScreen />
    </AppDashboard>
  );
};

export default AdminLLMCallPage;

